import React from 'react';
import { PinterestButton, PinterestButtonProps } from '../PinterestButton';
import { useToggle } from '../../wag-react/common/hooks/useToggle';
import { LazyImage, LazyImageProps } from '../../wag-react/components/lazyload/LazyImage';
import { Box, BoxProps } from '../../wag-react/next-components/box';
export type PinterestImageProps = BoxProps & Pick<PinterestButtonProps, 'url'> & {
  imageProps?: Omit<LazyImageProps, 'src'>;
};
export const PinterestImage = ({
  url,
  imageProps,
  ...rest
}: PinterestImageProps) => {
  const {
    on: isHovering,
    toggle: setIsHovering
  } = useToggle();
  return <Box position="relative" {...rest} data-sentry-element="Box" data-sentry-component="PinterestImage" data-sentry-source-file="index.tsx">
      <LazyImage src={url} onMouseEnter={() => setIsHovering(true)} onMouseLeave={() => setIsHovering(false)} {...imageProps} data-sentry-element="LazyImage" data-sentry-source-file="index.tsx" />
      <PinterestButton url={url} onMouseEnter={() => setIsHovering(true)} opacity={isHovering ? 1 : 0} data-sentry-element="PinterestButton" data-sentry-source-file="index.tsx" />
    </Box>;
};